import "./QuoteChangeComponentV2.scss";
import template from "./QuoteChangeComponentV2.html";
import {IComponentOptions} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";

export const QuoteChangeV2 = "tfQuoteChangeV2";

export function quoteChangeV2(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<quote"
        },
        controllerAs: "ctrl",
        controller: QuoteChangeComponentV2Controller
    };
}

export class QuoteChangeComponentV2Controller {
    public readonly model: QuoteViewModel;
}
